<template>
  <div class="mobility-slider-wrapper">
    <div class="teq-container">
      <div class="title">
        <h3>estimez rapidement le prix</h3>
        <p>de votre location</p>
      </div>
      <div class="content">
        <div class="left-menu">
          <p class="config-title">
            Configurez votre location
          </p>
          <div class="select-wrapper">
            <v-select
              label="value"
              :options="durationsList"
              @input="setDuration"
              :placeholder="'Durée de location'"
              :clearable="false"
              ref="filterDuration"
            >
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes">
                  <svg
                    class="chevron"
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.646894 0.555097C0.69334 0.508533 0.748515 0.47159 0.80926 0.446384C0.870005 0.421178 0.935127 0.408203 1.00089 0.408203C1.06666 0.408203 1.13178 0.421178 1.19253 0.446384C1.25327 0.47159 1.30845 0.508533 1.35489 0.555097L7.00089 6.2021L12.6469 0.555097C12.6934 0.508609 12.7486 0.471732 12.8093 0.446573C12.87 0.421414 12.9352 0.408465 13.0009 0.408465C13.0666 0.408465 13.1317 0.421414 13.1925 0.446573C13.2532 0.471732 13.3084 0.508609 13.3549 0.555097C13.4014 0.601585 13.4383 0.656774 13.4634 0.717513C13.4886 0.778253 13.5015 0.843353 13.5015 0.909097C13.5015 0.974841 13.4886 1.03994 13.4634 1.10068C13.4383 1.16142 13.4014 1.21661 13.3549 1.2631L7.35489 7.2631C7.30845 7.30966 7.25327 7.3466 7.19253 7.37181C7.13178 7.39702 7.06666 7.40999 7.00089 7.40999C6.93513 7.40999 6.87001 7.39702 6.80926 7.37181C6.74852 7.3466 6.69334 7.30966 6.64689 7.2631L0.646894 1.2631C0.600331 1.21665 0.563388 1.16148 0.538181 1.10073C0.512975 1.03999 0.5 0.974864 0.5 0.909097C0.5 0.843329 0.512975 0.778208 0.538181 0.717463C0.563388 0.656718 0.600331 0.601542 0.646894 0.555097Z"
                      fill="black"
                    ></path></svg></span>
              </template>
            </v-select>
          </div>

          <div class="select-wrapper">
            <v-select
              label="value"
              :options="categoriesList"
              @input="setSize"
              :placeholder="'Taille du véhicule'"
              :clearable="false"
              ref="filterCategory"
            >
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes">
                  <svg
                    class="chevron"
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.646894 0.555097C0.69334 0.508533 0.748515 0.47159 0.80926 0.446384C0.870005 0.421178 0.935127 0.408203 1.00089 0.408203C1.06666 0.408203 1.13178 0.421178 1.19253 0.446384C1.25327 0.47159 1.30845 0.508533 1.35489 0.555097L7.00089 6.2021L12.6469 0.555097C12.6934 0.508609 12.7486 0.471732 12.8093 0.446573C12.87 0.421414 12.9352 0.408465 13.0009 0.408465C13.0666 0.408465 13.1317 0.421414 13.1925 0.446573C13.2532 0.471732 13.3084 0.508609 13.3549 0.555097C13.4014 0.601585 13.4383 0.656774 13.4634 0.717513C13.4886 0.778253 13.5015 0.843353 13.5015 0.909097C13.5015 0.974841 13.4886 1.03994 13.4634 1.10068C13.4383 1.16142 13.4014 1.21661 13.3549 1.2631L7.35489 7.2631C7.30845 7.30966 7.25327 7.3466 7.19253 7.37181C7.13178 7.39702 7.06666 7.40999 7.00089 7.40999C6.93513 7.40999 6.87001 7.39702 6.80926 7.37181C6.74852 7.3466 6.69334 7.30966 6.64689 7.2631L0.646894 1.2631C0.600331 1.21665 0.563388 1.16148 0.538181 1.10073C0.512975 1.03999 0.5 0.974864 0.5 0.909097C0.5 0.843329 0.512975 0.778208 0.538181 0.717463C0.563388 0.656718 0.600331 0.601542 0.646894 0.555097Z"
                      fill="black"
                    ></path></svg></span>
              </template>
            </v-select>
          </div>

          <div class="select-wrapper">
            <v-select
              label="value"
              :options="motorisationsList"
              @input="setMotorization"
              :placeholder="'Motorisation'"
              :clearable="false"
              ref="filterMotor"
            >
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes">
                  <svg
                    class="chevron"
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.646894 0.555097C0.69334 0.508533 0.748515 0.47159 0.80926 0.446384C0.870005 0.421178 0.935127 0.408203 1.00089 0.408203C1.06666 0.408203 1.13178 0.421178 1.19253 0.446384C1.25327 0.47159 1.30845 0.508533 1.35489 0.555097L7.00089 6.2021L12.6469 0.555097C12.6934 0.508609 12.7486 0.471732 12.8093 0.446573C12.87 0.421414 12.9352 0.408465 13.0009 0.408465C13.0666 0.408465 13.1317 0.421414 13.1925 0.446573C13.2532 0.471732 13.3084 0.508609 13.3549 0.555097C13.4014 0.601585 13.4383 0.656774 13.4634 0.717513C13.4886 0.778253 13.5015 0.843353 13.5015 0.909097C13.5015 0.974841 13.4886 1.03994 13.4634 1.10068C13.4383 1.16142 13.4014 1.21661 13.3549 1.2631L7.35489 7.2631C7.30845 7.30966 7.25327 7.3466 7.19253 7.37181C7.13178 7.39702 7.06666 7.40999 7.00089 7.40999C6.93513 7.40999 6.87001 7.39702 6.80926 7.37181C6.74852 7.3466 6.69334 7.30966 6.64689 7.2631L0.646894 1.2631C0.600331 1.21665 0.563388 1.16148 0.538181 1.10073C0.512975 1.03999 0.5 0.974864 0.5 0.909097C0.5 0.843329 0.512975 0.778208 0.538181 0.717463C0.563388 0.656718 0.600331 0.601542 0.646894 0.555097Z"
                      fill="black"
                    ></path></svg></span>
              </template>
            </v-select>
          </div>
          <span
            v-if="error"
            class="error-text"
          >
            <svg
              width="17"
              height="15"
              viewBox="0 0 17 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.91925 5.03103H8.73447V8.36178L8.66459 11.2267H7.98913L7.91925 8.36178V5.03103ZM8.9678 12.6944C8.9678 13.1602 8.75817 13.3465 8.31521 13.3465C7.87308 13.3465 7.66345 13.1602 7.66345 12.6944C7.66345 12.2285 7.87308 12.0422 8.31521 12.0422C8.75817 12.0422 8.9678 12.2285 8.9678 12.6944ZM8.31524 1.70062L1.42083 14.1851H15.2097L8.31524 1.70062ZM8.31522 0L16.6304 15H0L8.31522 0Z"
                fill="white"
              ></path>
            </svg>
            Il semblerait qu’aucun véhicule ne corresponde à votre recherche, nous avons élargi la réponse aux véhicules équivalents
          </span>

          <p
            class="reset"
            @click="reset()"
          >
            <svg
              width="8"
              height="7"
              viewBox="0 0 8 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.79002 0L3.69975 3.01L0.609485 0L0.207031 0.39225L3.31141 3.402L0.235521 6.398L0.623601 6.776L3.69975 3.78025L6.77539 6.776L7.16321 6.398L4.08783 3.402L7.19221 0.39225L6.79002 0Z"
                fill="white"
              ></path>
            </svg>
            Réinitialiser ma recherche
          </p>
        </div>

        <div class="slider">
          <div class="swiper">
            <div
              class="swiper-wrapper"
              v-if="vehicles && vehicles.length >= 1"
            >
              <!-- Slides -->
              <div
                class="swiper-slide"
                v-for="(vehicle, index) in vehicles"
                :key="index"
              >
                <div class="slide-card">
                  <p class="size">
                    <template
                      v-for="(
                        category, key
                      ) in categoriesList"
                    >
                      <span
                        v-if="
                          category.key ==
                            vehicle.size_category
                        "
                        :key="key"
                      >
                        {{ category.value }}</span>
                    </template>
                  </p>
                  <img
                    :src="vehicle.images.high"
                    :alt="vehicle.label"
                  >
                  <!-- <img src="https://cloud.leparking.fr/2022/03/13/00/31/renault-twingo-renault-twingo-e-tech-electrique-renault-twingo-iii-e-tech-equilibre-5-portes_8449564743.jpg"> -->
                  <div class="bottom-part">
                    <div class="bottom-text">
                      <p class="brand">
                        {{ vehicle.label }}
                      </p>
                      <p
                        class="price"
                        v-if="(duration != null && duration != 'DAILY')"
                      >
                        {{ $t(`components.slider.price_${duration.toString().toLowerCase()}`, { price: vehicle['rrs_category']['starting_price_'+ duration.toString().toLowerCase()]['raw'] }) }}
                      </p>

                      <p
                        class="price"
                        v-if="
                          duration == null ||
                            duration == 'DAILY'
                        "
                      >
                        {{ $t('components.slider.price_daily', { price: vehicle.rrs_category.starting_price.raw } ) }}
                      </p>
                    </div>
                    <rent-button
                      is-anchor
                      :href="duration == 'HOURLY' ? 'https://share.mobilize.com/?hl=fr&utm_source=mobility-fr' : `/vehicules/${vehicle.slug}?price_by=${duration}`"
                    >
                      {{ duration == 'HOURLY' ? 'En savoir plus' : 'Voir ce modèle' }}
                    </rent-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- If we need pagination -->
          <div
            v-if="vehicles && vehicles.length >= 1"
            class="swiper-pagination"
          />
          <!-- If we need navigation buttons -->
          <div
            class="swiper-button-prev"
            v-if="vehicles && vehicles.length >= 1"
          >
            <svg
              width="19"
              height="17"
              viewBox="0 0 19 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 8.4082L1.5 8.4082M8.5 15.4082L1.5 8.4082L8.5 1.4082"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </div>
          <div
            class="swiper-button-next"
            v-if="vehicles.length >= 1"
          >
            <svg
              width="19"
              height="17"
              viewBox="0 0 19 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 8.4082H17.5M10.5 1.4082L17.5 8.4082L10.5 15.4082"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation, Pagination } from 'swiper'
import axios from 'axios'
import RentButton from '../shared/RentButton'

import 'swiper/swiper-bundle.css'
import 'vue-select/dist/vue-select.css'

Swiper.use([Navigation, Pagination])

export default {
  data() {
    return {
      duration: null,
      motorization: null,
      size_category: null,
      swiper: null,
      vehicles: [],
      error: false,
    }
  },
  components: {
    RentButton,
  },
  computed: {
    categoriesList() {
      return Object.entries(
                window.renaultRent?.vehicle_slider?.size_categories,
      ).map(([key, value]) => ({ key, value }))
    },
    motorisationsList() {
      return Object.entries(
                window.renaultRent?.vehicle_slider?.motorizations,
      ).map(([key, value]) => ({ key, value }))
    },
    durationsList() {
      return Object.entries(
                window.renaultRent?.vehicle_slider?.durations,
      ).map(([key, value]) => ({ key, value }))
    },
  },
  mounted() {
    this.vehiclesList()
    this.initSwiper()
  },

  methods: {

    initSwiper() {
      if (window.matchMedia('(max-width: 768px').matches) return
      setTimeout(() => {
        this.swiper = new Swiper('.mobility-slider-wrapper .swiper', {
          slidesPerView: 1.5,
          init: false,
          allowTouchMove: false,
          spaceBetween: 14,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
          },
        })

        this.swiper.on('init', () => {
          const progressBar = document.querySelector(
            '.mobility-slider-wrapper .swiper-pagination-progressbar-fill',
          )
          if (progressBar) {
            const allSlides = document.querySelectorAll(
              '.mobility-slider-wrapper .swiper-slide',
            )
            progressBar.style.background = '#000'
            progressBar.style.width = `${100 / allSlides.length}%`
            progressBar.style.transform = 'scaleX(1)'
          }
        })

        this.swiper.on('slideChange', () => {
          const allSlides = document.querySelectorAll(
            '.mobility-slider-wrapper .swiper-slide',
          )
          allSlides.forEach((slide) => {
            slide.classList.remove('active')
          })

          if (this.swiper.activeIndex === allSlides.length - 1) {
            allSlides[allSlides.length - 2].classList.add('active')
          }

          const progressBar = document.querySelector(
            '.mobility-slider-wrapper .swiper-pagination-progressbar-fill',
          )
          progressBar.style.transform = `translateX(${
            (this.swiper.activeIndex / (allSlides.length - 1))
                        * ((allSlides.length - 1) * 100)
          }%`
          progressBar.style.width = `${100 / allSlides.length}%`
        })

        this.swiper.init()
      }, 200)
    },
    reset() {
      this.vehiclesList()

      this.$refs.filterCategory.$refs.clearButton.click()
      this.$refs.filterDuration.$refs.clearButton.click()
      this.$refs.filterMotor.$refs.clearButton.click()

      this.duration = null
      this.motorization = null
      this.size_category = null
      this.error = false
    },

    setApi() {
      const baseApi = '/api/vehicles/slider?';
      const durationApi = `&duration=${this.duration}`;
      const motorizationAPi = `&motorization=${this.motorization}`
      const sizeApi = `&size_category=${this.size_category}`
      axios
        .get(
          baseApi + (this.duration != null ? durationApi : '') + (this.motorization != null ? motorizationAPi : '') + (this.size_category != null ? sizeApi : ''),
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        .then((response) => {
          if (response.data.data.length === 0) {
            this.error = true
            return
          }
          this.error = false
          this.vehicles = null
          this.vehicles = response.data.data
          this.initSwiper()
        })
        .catch((err) => {
          console.log(err)
        })
    },

    setDuration(value) {
      if (value === null) return
      this.duration = value.key
      this.setApi();
    },
    setMotorization(value) {
      if (value === null) return
      this.motorization = parseInt(value.key, 0)
      this.setApi();
    },

    setSize(value) {
      if (value === null) return
      this.size_category = value.key
      this.setApi();
    },
    vehiclesList() {
      axios
        .get('/api/vehicles/slider', {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          this.vehicles = response.data.data
          this.initSwiper()
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>

<style lang="scss">
@import '../../../sass/config/vars';
@import '../../../../_src/sass/config/responsive';

.vs__search {
  font-family: $f-graphie-semibold;

  &.vs--open {
    .vs__open-indicator {
      margin-right: 28px;
      transform: none !important;
      transition: none !important;
    }
  }
}

.vs--open .vs__open-indicator {
  margin-right: 29px;
  transform: rotate(180deg) !important;
  transition: none !important;
}

.vs__open-indicator {
  //margin-right: 28px;
  transform: none !important;
  transition: none !important;
}

.vs__selected {
  font-family: $f-graphie-semibold;
  font-size: 1.6rem;
  line-height: 1.9rem;
}

.vs__dropdown-option {
  border-bottom: 1px solid #d9d9d9;
  font-size: 14px;
  line-height: 30px;
}

.vs__dropdown-menu {
  padding-bottom: 0;
}

.vs__dropdown-toggle {
  border: none;
  border-radius: 0;
  padding: 1.5rem;
}

.swiper-slide {
  .rent-button {
    @include teq-breakpoint($medium) {
      opacity: 0;
    }
  }
}

.swiper-slide-active {
  img {
    // margin: 0 auto;
    width: calc(100% - 16px) !important;
  }

  .rent-button {
    opacity: 1;
  }
}
</style>
<style scoped lang="scss">
@import '../../../sass/config/vars';
@import '../../../../_src/sass/config/responsive';

.mobility-slider-wrapper {
  margin-top: 10.5rem;

  @include teq-breakpoint($medium) {
    margin-top: 8rem;
  }
}

.teq-container {
  margin-bottom: 40px;
}

.title {
  margin-bottom: 77px;
  padding-bottom: 24px;
  position: relative;
  text-align: center;

  h3 {
    font-size: 60px;
    font-weight: 800;
    line-height: 72px;
  }

  p {
    font-size: 24px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 0;
  }

  &::after {
    background: #000;
    bottom: 0;
    content: '';
    height: 3px;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    width: 65px;
  }
}

.content {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;

  @include teq-breakpoint(0, $medium) {
    flex-direction: column;
  }
}

.left-menu {
  background: #f45000;
  padding: 24px;
  width: 100%;

  @include teq-breakpoint($medium) {
    width: 280px;
  }

  .config-title {
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    line-height: 25px;
    margin-bottom: 40px;
  }

  .error-text {
    color: white;
    font-family: $f-graphie-semibold;
    font-size: 1.4rem;
    line-height: 120%;
  }
}

.slider {
  background: white;
  position: relative;
  width: 100%;

  @include teq-breakpoint($medium) {
    width: calc(100% - 280px - 14px);
  }

  .swiper,
  .swiper-slide {
    height: 100%;
  }

  .swiper-wrapper {
    align-items: stretch;
    display: flex;

    @include teq-breakpoint(0, $medium) {
      flex-direction: column;
      gap: 16px;
    }
  }

  .swiper-slide {
    height: 100%;

    @include teq-breakpoint(0, $medium) {
      width: 100% !important;
    }

    .bottom-part {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0 16px;

      @include teq-breakpoint($medium) {
        align-items: center;
        flex-direction: row;
        padding: 0 32px;
      }

      .bottom-text {
        width: 100%;

        @include teq-breakpoint($medium) {
          width: 65%;
        }
      }

      .brand {
        font-family: $f-graphie-book;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 6px;

        @include teq-breakpoint($medium) {
          font-family: $f-graphie-semibold;
        }
      }

      .price {
        font-family: $f-graphie-semibold;
        font-size: 18px;
        line-height: 18px;
      }
    }

    img {
      height: 100%;
      max-height: 153px;
      mix-blend-mode: multiply;
      object-fit: contain;
      padding: 3rem 8px 0;
      transition: width 0.31s, right 0.3s !important;

      @include teq-breakpoint($medium) {
        max-height: 319px;
        padding: 0 8px;
        width: calc(100% - 16px);
      }
    }

    .size {
      left: 32px;
      position: absolute;
      top: 16px;
      transition: left 0.3s;
    }

    &.active {
      img {
        right: -50% !important;
        transition: right 0.3s, width 0.3s !important;
        width: calc(50% - 28px) !important;
      }

      button {
        display: none;
      }

      .size {
        left: calc(50% + 28px);
      }

      .bottom-part {
        flex-direction: row-reverse;
        justify-content: flex-end;

        .bottom-text {
          width: auto;
          width: calc(50% - 28px);
        }
      }
    }
  }
}

.select {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  border: none;
  border-radius: 0;
  color: black;
  font-family: 'Graphie SemiBold';
  font-size: 16px;
  font-weight: 700;
  outline: none;
  padding: 16px;
  width: 100%;
}

.select-wrapper {
  position: relative;

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  .chevron {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.reset {
  color: #fff;
  cursor: pointer;
  font-family: $f-graphie-book;
  font-size: 1rem;
  line-height: 1rem;
  margin: 32px 0 0;
}

// .swiper-slide-next {
//   align-items: flex-start;
//   height: 100%;

//   img {
//     @include teq-breakpoint($medium) {
//       width: calc(50% - 28px) !important;
//     }
//   }
// }

// .slide-card {
//   background: #eee;
//   display: flex;
//   flex-direction: column;
//   height: 100%;

//   img {
//     padding: 0 8px;
//     position: relative;
//     right: 0;
//     transition: right 0.3s, width 0.3s;
//     width: calc(100% - 16px);
//   }
// }
.swiper-slide-next {
  align-items: flex-start;
  height: 100%;

  img {
    transition: right 0.3s;
  }

  img {
    @include teq-breakpoint($medium) {
      padding: 0 8px !important;
      width: calc(50% - 16px) !important;
    }
  }
}

.slide-card {
  background: #eee;
  display: flex;
  flex-direction: column;
  height: 100%;

  img {
    aspect-ratio: 1/1;
    position: relative;
    right: 0;
    transition: right 0.3s, width 0.3s;
  }
}

.swiper-button-prev,
.swiper-button-next {
  left: calc(100% - 24px);
  position: absolute;
  top: calc(100% + 24px);

  &::after {
    display: none;
  }
}

.swiper-button-prev {
  left: calc(100% - 64px);
}

.swiper-pagination {
  position: absolute;
  top: calc(100% + 22px);
  width: calc(100% - 92px);
}

.swiper-pagination,
.swiper-button-prev,
.swiper-button-next {
  @include teq-breakpoint(0, $medium) {
    display: none;
  }
}

.swiper-pagination-progressbar {
  background: #c4c4c4;

  .swiper-pagination-progressbar-fill {
    width: 25%;
  }
}

.rent-button {
  background-color: $orange;
  border: none;
  max-width: none;
  padding: 0;

  @include teq-breakpoint($medium) {
    padding: 0 3rem;
  }

  &:hover,
  &:active {
    background-color: #000;
    border: 1px solid #000;
    border: none;
    color: #fff;
  }

  &:focus {
    border: none;
  }
}

</style>
